import { StudentRepository } from '../../domain/student-repository';
import {
	AnonymousStudentProfileSynced,
	AnonymousStudentProfileUpdated,
	EventType,
} from '@studyportals/anonymous-student-interfaces';
import { IStudent } from '@studyportals/studentdomain';
import { StudentField } from '@studyportals/studentdomain';
import globals from '../../utils/globals';
import { store } from '../store';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';

export class ProfileDataCheckerPlugin
implements
		ISubscriber<AnonymousStudentProfileUpdated | AnonymousStudentProfileSynced>
{
	private studentRepository: StudentRepository;

	constructor() {
		this.studentRepository = new StudentRepository();
	}

	public async notify(
		event: AnonymousStudentProfileUpdated | AnonymousStudentProfileSynced,
	): Promise<void> {
		const _event = event as any;
		await this.handleCompleteness(_event.changes as IStudent | undefined);
	}

	public async initiate(): Promise<void> {
		const userData = await this.studentRepository.getFields([
			StudentField.TUITION_BUDGET,
			StudentField.NATIONALITY_COUNTRY_ID,
			StudentField.RESIDENCE_COUNTRY_ID,
			StudentField.CURRENCY,
			StudentField.LIVING_BUDGET,
			StudentField.WORK_EXPERIENCE,
			StudentField.GPA
		]);
		await this.handleCompleteness();

		if (userData !== null) {
			store.mutations.setTuitionBudget(
				userData[StudentField.TUITION_BUDGET],
			);

			store.mutations.setUserNationality(
				userData[StudentField.NATIONALITY_COUNTRY_ID],
			);

			store.mutations.setUserCountryOfResidence(
				userData[StudentField.RESIDENCE_COUNTRY_ID],
			);

			store.mutations.setCurrency(userData[StudentField.CURRENCY]);

			store.mutations.setLivingBudget(userData[StudentField.LIVING_BUDGET]);
			store.mutations.setWorkExperience(
				userData[StudentField.WORK_EXPERIENCE],
			);
			store.mutations.setGpa(userData[StudentField.GPA]);
		}

		globals.eventAggregationService.subscribeTo(
			EventType.AnonymousStudentProfileUpdated,
			this,
		);
		globals.eventAggregationService.subscribeTo(
			EventType.AnonymousStudentProfileSynced,
			this,
		);
	}

	private async handleCompleteness(changes?: IStudent): Promise<void> {
		const completeness = await this.studentRepository.getCompleteness();

		store.mutations.setProfileCompleteness(completeness);
		await store.actions.studentDataUpdated(changes);
	}
}
